import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/headers/PageHeader';
import {
  Table,
  Button,
  message,
  Form,
  Input,
  DatePicker,
  Row,
  Skeleton,
  Col,
} from 'antd';
import ContratosTrabajadoresColumns from './componnetsTabs/ContratosTrabajadoresColumns';
import backofficeService from '../../../services/backofficeService';
import Labels from '../../../utils/Labels.json';
import locale from 'antd/es/date-picker/locale/es_ES';
import dayjs from 'dayjs';
import BotonDescargaMasiva from './Xinerlink/BotonDescargaMasiva';
import BotonDescargaExcel from './Xinerlink/BotonDescargaExcel';

export default function TabContratosTrabajadores({ setRefresh, refresh }) {
  const tipo = 'contratosTrabajador';
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingRefersh, setLoadingRefersh] = useState(true);
  const [loading, setLoading] = useState(true);
  const [openedRecord, setOpenedRecord] = useState(null);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(selectedRowKeys);
      setSelectedRowKeys(selectedRows);
    },
  };

  const AjusteArrayTrabajadores = (data) => {
    const arrayTrabajadoresContratos = [];
    if (data.length !== 0) {
      const arrayFiltrado = data.filter((item) => item.idContrato !== 0);
      arrayFiltrado.forEach(function (obj) {
        let nexElement = obj;
        nexElement.idOferta = obj.idOferta.toString();
        nexElement.idContrato = obj.idContrato.toString();
        nexElement.key = obj.idContrato.toString() + obj.idOferta.toString();

        if (
          obj.estadoContrato === 'ContratoFirmadoXRepLegal' ||
          obj.estadoContrato === 'Firmado'
        ) {
          nexElement.estadoContrato = 'Firmado';
        } else {
          nexElement.estadoContrato = 'Falta Firma';
        }
        arrayTrabajadoresContratos.unshift(nexElement);
      });
      arrayTrabajadoresContratos.sort((a, b) => b.idOferta - a.idOferta);
      setFilteredData(arrayTrabajadoresContratos);

      setLoadingRefersh(false);
      setLoading(false);
    } else {
      setFilteredData([]);
      setLoadingRefersh(false);
      setLoading(false);
    }
  };

  const VerContratos = async () => {
    const fechaInicio = new Date();
    const fechaFin = new Date();
    // const fechaInicio = new Date('2023-10-06 12:00:00');
    // const fechaFin = new Date('2023-10-06 12:00:00');
    if (fechaFin.getDay() !== 1) {
      const diffDias = fechaFin.getDay() === 0 ? 6 : fechaFin.getDay() - 1;
      const inicioSemana = fechaInicio.getDate() - diffDias;
      fechaInicio.setDate(inicioSemana);
      const fechaInicioFormat = dayjs(fechaInicio).format('YYYY-MM-DD');
      const fechaFinFormat = dayjs(fechaFin).format('YYYY-MM-DD');
      try {
        const [res] = await backofficeService.contratosTrabajador(
          tipo,
          rut,
          fechaInicioFormat,
          fechaFinFormat
        );
        if (res.data.ok) {
          AjusteArrayTrabajadores(res.data.registro.contratos || []);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const fechaInicioFormat = dayjs(fechaInicio).format('YYYY-MM-DD');
        const fechaFinFormat = dayjs(fechaFin).format('YYYY-MM-DD');
        const [res] = await backofficeService.contratosTrabajador(
          tipo,
          rut,
          fechaInicioFormat,
          fechaFinFormat
        );
        if (res.data.ok) {
          AjusteArrayTrabajadores(res.data.registro.contratos || []);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [filteredData, setFilteredData] = useState([]);
  const [rut, setRut] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSearch = async () => {
    setLoading(true);
    var utc = require('dayjs/plugin/utc');
    dayjs.extend(utc);
    if (startDate === null || endDate === null) {
      message.error('Debe seleccionar un rango de fechas');
      setLoading(false);
      return;
    } else if (startDate > endDate) {
      message.error(
        'La fecha de inicio no puede ser mayor a la fecha de término'
      );
      setLoading(false);
      return;
    }

    const desde = dayjs(startDate).utc().format('YYYY-MM-DD');
    const hasta = dayjs(endDate).utc().format('YYYY-MM-DD');
    try {
      const respuestaContratos = await backofficeService.contratosTrabajador(
        tipo,
        rut,
        desde,
        hasta
      );
      // debug && console.log(respuestaContratos);
      if (respuestaContratos[0].data.ok) {
        const contratos = respuestaContratos[0].data.registro.contratos;
        AjusteArrayTrabajadores(contratos || []);
      } else {
        setFilteredData([]);
        setLoadingRefersh(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReset = () => {
    setRut('');
    setLoading(true);
    VerContratos();
  };

  useEffect(() => {
    VerContratos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  return (
    <div>
      <PageHeader title="Contratos Trabajadores" head="">
        <BotonDescargaMasiva
          selectedRowKeys={selectedRowKeys}
          tipo="Contratos"
        />
        <BotonDescargaMasiva
          selectedRowKeys={selectedRowKeys}
          tipo="Documentos"
        />
        <BotonDescargaExcel
          data={filteredData}
          filename="ContratosTrabajadores"
        />
      </PageHeader>
      {loadingRefersh ? (
        <Skeleton />
      ) : (
        <div style={{ margin: '10px' }}>
          <Row style={{ marginBotton: '20px' }}>
            <Col>
              <div style={{ marginTop: '5px', marginRight: '10px' }}>
                Filtro por fecha o RUT:
              </div>{' '}
            </Col>
            <Col>
              {' '}
              <Form layout="inline">
                <Form.Item label="RUT">
                  <Input
                    placeholder="Rut"
                    style={{ width: '100%' }}
                    onChange={(e) => {
                      setRut(e.target.value);
                    }}
                  />
                </Form.Item>
                <Form.Item label="Desde">
                  <DatePicker
                    placeholder="Desde"
                    onChange={(date) => setStartDate(date)}
                    style={{ width: '100%' }}
                    locale={locale}
                    format={'DD/MM/YYYY'}
                  />
                </Form.Item>
                <Form.Item label="Hasta">
                  <DatePicker
                    placeholder="Hasta"
                    onChange={(date) => setEndDate(date)}
                    style={{ width: '100%' }}
                    locale={locale}
                    format={'DD/MM/YYYY'}
                  />
                </Form.Item>
                <Form.Item>
                  <Input type="submit" value="Buscar" onClick={handleSearch} />
                </Form.Item>
              </Form>
            </Col>
            <Col>
              <Button onClick={() => handleReset()}> Borrar</Button>
            </Col>
          </Row>

          <Table
            style={{ marginTop: '20px' }}
            rowKey="key"
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}
            pagination={{ showSizeChanger: true }}
            locale={Labels['tableLabels']}
            loading={loading}
            dataSource={filteredData}
            columns={ContratosTrabajadoresColumns(
              filteredData,
              openedRecord,
              setOpenedRecord
            )}
            scroll={{ x: 'max-content' }}
          />
        </div>
      )}
    </div>
  );
}
